import SubscriptionPlan from '@/types/Subscription/SubscriptionPlan';

export default (subscriptionPlans: SubscriptionPlan[]) => {
    const getSubscriptionPlanForUuid = (uuid: string) => {
        const plan = subscriptionPlans.find((a) => a.uuid === uuid);

        if (!plan) {
            throw new Error('Subscription plan not found');
        }

        return plan;
    };

    const getMonthlyPriceForUsersForSubscriptionPlan = (uuid: string) => {
        const subscriptionPlan = getSubscriptionPlanForUuid(uuid);

        if (subscriptionPlan.users_price === null) {
            return 0;
        }

        return subscriptionPlan.users_price / 100;
    };

    const getMonthlyPriceForSubscriptionPlan = (uuid: string) => {
        const subscriptionPlan = getSubscriptionPlanForUuid(uuid);

        const price = subscriptionPlan.price / 100;

        if (subscriptionPlan.period === 1) {
            return price;
        } else {
            return price / 12;
        }
    };

    return {
        getMonthlyPriceForSubscriptionPlan,
        getMonthlyPriceForUsersForSubscriptionPlan,
    };
};
